import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    meta: {
      auth: true
    },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('./../views/subscriptions/index.vue')
      },
      {
        path: '/dist-transfers',
        name: 'distributor-transfer',
        component: () => import('./../views/distributors/transfers/index.vue')
      },
      {
        path: "account",
        component: () => import("./../views/account/index.vue"),
        children: [
          {
            path: "",
            name: "account",
            component: () => import("./../views/account/profile.vue")
          },
          {
            path: "api",
            name: "account-api",
            component: () => import("./../views/account/api.vue")
          },
          {
            path: "security",
            name: "account-security",
            component: () => import("./../views/account/security.vue")
          }
        ]
      },
      {
        path: '/users',
        name: 'user',
        component: () => import('./../views/users/index.vue'),
        meta: {
          auth: ['ROLE_ADMIN']
        }
      },
      {
        path: '/users/add',
        name: 'user-add',
        component: () => import('./../views/users/add.vue'),
        meta: {
          auth: ['ROLE_ADMIN']
        }
      },
      {
        path: '/users/edit/:id([0-9]+)',
        name: 'user-edit',
        component: () => import('./../views/users/edit.vue'),
        meta: {
          auth: ['ROLE_ADMIN']
        }
      },
      {
        path: '/cga-manager',
        name: 'cga-manager',
        component: () => import('./../views/cga/manager/index.vue'),
        meta: {
          auth: ['ROLE_ADMIN']
        }
      },
    ]
  },
  {
    path: '/login',
    component: () => import('./../views/security/login.vue'),
    name: 'login'
  },
  {
    path: '/logout',
    component: () => import('./../views/security/logout.vue'),
    name: 'logout'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

Vue.router = router;
export default router
